export const hidenMessageAPI = ["user-preferences-general", "/api/auth/login/"];
